import { FC, PropsWithChildren, useCallback } from 'react';

import { ImageComponent } from '../Image';
import { useLabels } from '@/hooks/labels';
import { useNavigation } from '@/hooks/navigation';

import { ScLabelsSection, ScPromoLabel } from './styled';

export interface PromoLabel {
  character: string;
  background: string;
  url?: string;
  onClick?: () => void;
  available?: boolean;
  disableAnimation?: boolean;
  counter?: number | null;
}

interface LabelsSectionProps {
  onLabelClick?: () => void;
}

export const LabelsSection: FC<PropsWithChildren<LabelsSectionProps>> = ({
  children,
  onLabelClick,
}) => {
  const labels = useLabels();

  const availableLabels = labels.filter((label) => label.available);

  if (!availableLabels.length && !children) {
    return null;
  }

  const handleLabelClick = (onClick?: PromoLabel['onClick']) => {
    onClick && onClick();
    onLabelClick && onLabelClick();
  };

  return (
    <>
      <div className="divider" />

      <ScLabelsSection>
        {availableLabels?.map((label, index) =>
          label.available ? (
            <PromoLabelItem
              {...label}
              key={index}
              onClick={() => handleLabelClick(label.onClick)}
            />
          ) : null
        )}
        {children && <ScPromoLabel>{children}</ScPromoLabel>}
      </ScLabelsSection>
    </>
  );
};

const PromoLabelItem: FC<PromoLabel> = ({
  character,
  background,
  url,
  disableAnimation,
  onClick,
  counter,
}) => {
  const { navigate } = useNavigation();

  const handleClick = useCallback(() => {
    url && navigate(url);
    onClick && onClick();
  }, [url, onClick, navigate]);

  return (
    <ScPromoLabel disableAnimation={disableAnimation} onClick={handleClick}>
      <div className="label">
        <ImageComponent src={character} fill alt="label" />
        {counter && <span>{counter}</span>}
      </div>
      <ImageComponent src={background} width={40} height={40} alt="bg" />
    </ScPromoLabel>
  );
};
